import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import SharedService from "../../services/shared-service";
import {
  GET_CURRENT_USER,
  GET_PERMISSION,
  GET_COUNTRY_LIST,
  GET_NOTIFICATION_LIST,
  GET_CONFIG_CHOICE,
  GET_MULTIPLE_CONFIG_CHOICE,
} from "../actions";
import {
  getCurrentUserSuccess,
  getCurrentUserError,
  getPermissionSuccess,
  getPermissionError,
  getCountryListSuccess,
  getCountryListError,
  getNotificationListSuccess,
  getNotificationListError,
  getConfigChoiceSuccess,
  getConfigChoiceError,
  getMultipleConfigChoiceSuccess,
  getMultipleConfigChoiceError,
} from "./action";

export function* watchGetCurrentUser() {
  yield takeEvery(GET_CURRENT_USER, getCurrentUser);
}

const getCurrentUserAsync = async (id) => {
  return SharedService.getCurrentUser(id);
};

function* getCurrentUser() {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  try {
    const response = yield call(getCurrentUserAsync, currentUser?.id);
    if (response.data.success) {
      yield put(getCurrentUserSuccess(response.data.data));
    } else {
      yield put(getCurrentUserError(response.data.message));
    }
  } catch (error) {
    yield put(getCurrentUserError(error.response.data.message));
  }
}

export function* watchGetPermission() {
  yield takeEvery(GET_PERMISSION, getPermission);
}

const getPermissionAsync = async (id) => {
  return SharedService.getPermission(id);
};

function* getPermission({ payload }) {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  try {
    const response = yield call(getPermissionAsync, currentUser?.roleId);
    if (response.data.success) {
      // const byPass = [{ module: "productManagement", submenu: ['menu'] }]
      const byPass = payload?.restrictSubmenu ?? []
      const perm = response.data.data
      let newPerm = perm.map(item => {
        const module = byPass.find(el => el.module === item.key)
        if (module) {
          return {
            ...item, section: item.section.filter(element => {
              return !module.submenu.includes(element.key)
            })
          }
        } else {
          return item
        }
      })
      yield put(getPermissionSuccess(newPerm));
    } else {
      yield put(getPermissionError(response?.data?.message ?? 'Something went wrong'));
    }
  } catch (error) {
    yield put(getPermissionError(error?.response?.data?.message));
  }
}

export function* watchGetCountryList() {
  yield takeEvery(GET_COUNTRY_LIST, getCountryList);
}

const getCountryListAsync = async () => {
  return SharedService.getCountryList();
};

function* getCountryList() {
  try {
    const response = yield call(getCountryListAsync);
    if (response.data.success) {
      yield put(getCountryListSuccess(response.data.data));
    } else {
      yield put(getCountryListError(response.data.message));
    }
  } catch (error) {
    yield put(getCountryListError(error.response.data.message));
  }
}

export function* watchGetNotificationList() {
  yield takeEvery(GET_NOTIFICATION_LIST, getNotificationList);
}

const getNotificationListAsync = async (param) => {
  return SharedService.getNotificationList(param);
};

function* getNotificationList({ payload }) {
  try {
    const response = yield call(getNotificationListAsync, payload.param);
    if (response.data.success) {
      yield put(getNotificationListSuccess(response.data));
    } else {
      yield put(getNotificationListError(response.data.message));
    }
  } catch (error) {
    yield put(getNotificationListError(error.response.data.message));
  }
}

export function* watchGetConfigChoice() {
  yield takeEvery(GET_CONFIG_CHOICE, getConfigChoice);
}

const getConfigChoiceAsync = async (category) => {
  return SharedService.getConfigChoice(category);
};

function* getConfigChoice({ payload }) {
  try {
    const response = yield call(getConfigChoiceAsync, payload.category);
    if (response.data.success) {
      yield put(getConfigChoiceSuccess(response.data.data));
    } else {
      yield put(getConfigChoiceError(response.data.message));
    }
  } catch (error) {
    yield put(getConfigChoiceError(error.response.data.message));
  }
}

export function* watchGetMultipleConfigChoice() {
  yield takeEvery(GET_MULTIPLE_CONFIG_CHOICE, getMultipleConfigChoice);
}

const getMultipleConfigChoiceAsync = async (categories) => {
  return SharedService.getMultipleConfigChoice(categories);
};

function* getMultipleConfigChoice({ payload }) {
  try {
    const response = yield call(
      getMultipleConfigChoiceAsync,
      payload.categories
    );
    if (response.data.success) {
      yield put(getMultipleConfigChoiceSuccess(response.data.data));
    } else {
      yield put(getMultipleConfigChoiceError(response.data.message));
    }
  } catch (error) {
    yield put(getMultipleConfigChoiceError(error.response.data.message));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetCurrentUser),
    fork(watchGetPermission),
    fork(watchGetCountryList),
    fork(watchGetNotificationList),
    fork(watchGetConfigChoice),
    fork(watchGetMultipleConfigChoice),
  ]);
}
